import { enableFade } from 'core/handlers/FadeHandler'
import { enableScroll } from 'core/handlers/ScrollHandler'
import { signal } from 'services/SignalsService'

export default class GameRulesEntity extends PIXI.Container {
  constructor() {
    super()
    const fade = enableFade(this)

    signal.on('RADIO:menu', (value) => {
      fade(value == 'gamerules')
    })

    enableScroll(this)
  }
}
